import Image from '@/components/image';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import { event_button_click, event_installment_option } from '@/utils/gtm';
import { useEffect, useRef, useState } from 'react';
import MadfuWidgetModal from '../ui/modals/madfu-widget-modal';
import InstallmentText from './InstallmentText';

const MadfuWidget = ({ amount, locale, buttonLocation }) => {
  const [show, setShow] = useState(false);
  const refModel = useRef();
  const refBtn = useRef();

  useOnClickOutside([refModel, refBtn], () => setShow(false));

  useEffect(() => {
    if (show) {
      event_installment_option({ merchant_name: 'madfu' });
      event_button_click({
        button_name: 'Madfu',
        button_destination: 'open_bnpl_info',
        button_location: buttonLocation,
      });
    }
  }, [show, buttonLocation]);

  return (
    <div className='border-border flex min-h-[55px] items-center rounded-md border bg-white px-1'>
      <div
        ref={refBtn}
        className='flex items-center'
        onClick={() => setShow((show) => !show)}
      >
        <Image
          src={`/imgs/payments/madfu-logo-${locale}.png`}
          alt='madfu logo'
          width={85}
          height={28}
          className='h-[28px] w-[85px] object-contain'
        />
        <InstallmentText
          {...{
            locale,
            payNum: 6,
            mainPrice: Math.round(amount / 6) || '',
            onClick: () => null,
          }}
        />
      </div>
      {show ? (
        <MadfuWidgetModal
          {...{ locale, onHide: () => setShow(false), amount, show }}
        />
      ) : null}
    </div>
  );
};

export default MadfuWidget;
